<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form id="brand-form">
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="brandName"
          :label="$t('Name')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('brandName')">{{
          errors.first("brandName")
        }}</span>

        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.persianName"
          name="bpersianName"
          :label="$t('PersianName')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('bpersianName')">{{
          errors.first("bpersianName")
        }}</span>

        <vs-textarea
          v-model="model.description"
          name="Description"
          :label="$t('Description')"
          rows="1"
        />

        <vs-textarea
          v-model="model.metaDescription"
          name="metaDescription"
          :label="$t('MetaDescription')"
          rows="1"
        />
        <vs-textarea
          v-model="model.metaKeywords"
          name="keywords"
          :label="$t('KeyWords')"
          rows="1"
        />
        <div class="vx-row mb-4 justify-content-md-center">
          <div class="vx-col sm:w-1/4 w-full">
            <div class="uploader-box">
              <my-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="showUploader"
                :width="100"
                :height="100"
                langType="fa"
                :noCircle="true"
                img-format="jpg"
              ></my-upload>
              <img v-bind:src="model.logoImage" />
              <img
                :src="URLS_CONSTANTS.assets + 'BrandLogo/' + model.logoUri"
                v-if="model.logoUri"
              />
            </div>
            <a class="uploadImg img-box" @click.prevent="toggleShow">
              <i class="material-icons notranslate"> cloud_upload </i>
              {{ $t("LogoImage") }}
            </a>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <div class="uploader-box">
              <my-upload
                field="img"
                @crop-success="cropCoverSuccess"
                v-model="showCoverUploader"
                :width="100"
                :height="100"
                langType="fa"
                :noCircle="true"
                img-format="jpg"
              ></my-upload>
              <img v-bind:src="model.coverImage" v-if="model.coverImage" />
              <img
                :src="URLS_CONSTANTS.assets + 'Brand/' + model.coverUri"
                v-if="model.coverUri"
              />
            </div>
            <a class="uploadImg img-box" @click.prevent="toggleCoverShow">
              <i class="material-icons notranslate"> cloud_upload </i
              >{{ $t("CoverImage") }}
            </a>
          </div>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
#brand-form .uploader-box > img {
  top: 0;
  -webkit-transform: unset;
  transform: unset;
}
</style>

<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import myUpload from "vue-image-crop-upload";

const dict = {
  custom: {
    brandName: {
      required: "لطفا نام برند را وارد نمایید.",
    },
    bpersianName: {
      required: "لطفا نام فارسی برند را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      showUploader: false,
      showCoverUploader: false,
      brandName: "",
      bpersianName: "",
      popupTitle: "",
      keyWordValue: [],
      keyWordOptions: [],
      disabled: false,
      URLS_CONSTANTS: URLS_CONSTANTS,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createBrand: "brand/create",
      updateBrand: "brand/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.id != null) {
            this.updateBrand(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createBrand(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        }
      });
    },

    cropSuccess(imgDataUrl) {
      this.model.logoImage = imgDataUrl;
    },
    cropCoverSuccess(imgDataUrl) {
      this.model.coverImage = imgDataUrl;
    },
    toggleShow() {
      this.showUploader = !this.showUploader;
    },
    toggleCoverShow() {
      this.showCoverUploader = !this.showCoverUploader;
    },
    removeCoverImg() {
      this.model.coverImage = "";
    },
    removeUriImg() {
      this.model.logoImage = "";
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.model.id) {
          this.popupTitle = "EditBrand";
        } else {
          this.popupTitle = "CreateNewBrand";
          this.model.logoImage = "";
          this.model.coverImage = "";
        }
      }
      this.$validator.reset();
    },
  },
  components: {
    "v-select": vSelect,
    "my-upload": myUpload,
  },
};
</script>
